import { render, staticRenderFns } from "./AddEquAccount.vue?vue&type=template&id=628ba767&scoped=true"
import script from "./AddEquAccount.vue?vue&type=script&lang=js"
export * from "./AddEquAccount.vue?vue&type=script&lang=js"
import style0 from "./AddEquAccount.vue?vue&type=style&index=0&id=628ba767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ba767",
  null
  
)

export default component.exports